import React from 'react';

const ROW_LABELS = 8;
const COLUMNS = 2;

function Bone({ className = '' }) {
  return <div className={`animate-pulse rounded bg-gray-200 ${className}`} />;
}

/**
 * Skeleton da página de comparação — espelha header + tabela enquanto carrega.
 */
export default function ComparisonSkeleton() {
  return (
    <div
      className="min-h-screen bg-gray-50 py-8"
      style={{ fontFamily: 'Montserrat, sans-serif' }}
      aria-busy="true"
      aria-label="Carregando comparação"
    >
      <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 flex flex-wrap items-center gap-2">
          <Bone className="h-4 w-14" />
          <Bone className="h-4 w-3" />
          <Bone className="h-4 w-24" />
          <Bone className="h-4 w-3" />
          <Bone className="h-4 w-40" />
        </div>

        <div className="mb-8">
          <div className="mb-4 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <Bone className="mx-auto h-9 w-72 max-w-full lg:mx-0" />
            <div className="flex flex-col gap-2 sm:flex-row">
              <Bone className="h-10 w-full sm:w-48" />
              <Bone className="h-10 w-full sm:w-40" />
            </div>
          </div>
          <Bone className="h-5 w-56" />
        </div>

        <div className="overflow-hidden rounded-lg bg-white shadow-lg">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left">
                    <Bone className="h-4 w-24" />
                  </th>
                  {Array.from({ length: COLUMNS }, (_, i) => (
                    <th key={i} className="px-6 py-4">
                      <div className="flex flex-col items-center gap-2">
                        <Bone className="h-32 w-64 max-w-full rounded-lg" />
                        <Bone className="h-3 w-16" />
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {Array.from({ length: ROW_LABELS }, (_, rowIndex) => (
                  <tr key={rowIndex} className={rowIndex % 2 === 1 ? 'bg-gray-50' : undefined}>
                    <td className="px-6 py-4">
                      <Bone className="h-4 w-20" />
                    </td>
                    {Array.from({ length: COLUMNS }, (_, colIndex) => (
                      <td key={colIndex} className="px-6 py-4">
                        <div className="flex justify-center">
                          <Bone
                            className={`h-4 ${
                              rowIndex === 0 ? 'w-40' : rowIndex === 1 ? 'w-28' : 'w-16'
                            }`}
                          />
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 flex justify-center">
          <Bone className="h-12 w-56 rounded-md" />
        </div>
      </div>
    </div>
  );
}
